import { Component, Input } from '@angular/core';

const COLORS: Record<string, string> = {
    'Óptima': '#16a34a',
    'Buena': '#22c55e',
    'Media': '#eab308',
    'Alta': '#f97316',
    'Crítica': '#e11d48',
};

/** Punto de color + etiqueta ("Crítica/Alta/Media/Buena/Óptima") de las tablas de ranking. */
@Component({
    selector: 'app-efficiency-badge',
    template: `<span class="efficiency-badge"><span class="dot" [style.background]="color"></span>{{label}}</span>`,
    styles: [`
        .efficiency-badge { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; color: #344054; white-space: nowrap; }
        .dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
    `]
})
export class EfficiencyBadgeComponent {
    @Input() label = 'Media';

    get color(): string {
        return COLORS[this.label] || COLORS['Media'];
    }
}
